import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/desc',
        name: 'Desc',
        component: () => import('../views/Desc.vue')
    },
    {
        path: '/notice',
        name: 'Notice',
        component: () => import('../views/Notice.vue')
    },
    {
        path: '/rule',
        name: 'Rule',
        component: () => import('../views/Rule.vue')
    },
    {
        path: '/upload',
        name: 'Upload',
        component: () => import('../views/Upload.vue')
    },
    {
        path: '/apply',
        name: 'Apply',
        component: () => import('../views/Apply.vue')
    },
    {
        path: '/examhome',
        name: 'ExamHome',
        component: () => import('../views/exam/Home.vue')
    },
    {
        path: '/rank',
        name: 'Rank',
        component: () => import('../views/exam/Rank.vue')
    },
    {
        path: '/myscore',
        name: 'MyScore',
        component: () => import('../views/exam/MyScore.vue')
    },
    {
        path: '/status',
        name: 'Status',
        component: () => import('../views/exam/Status.vue')
    },
    {
        path: '/exam',
        name: 'Exam',
        component: () => import('../views/exam/Exam.vue')
    },
    {
        path: '/result',
        name: 'Result',
        component: () => import('../views/exam/Result.vue')
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
